// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"337":"c6da0cfda88eaf915494","936":"89597b3fbb918ae7ed58"}[chunkId] + ".js";
};